
<div fxLayout="row wrap" fxLayoutAlign="center">

  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando">
    <mat-tab-group style="width: 100%; background: white;">
      <mat-tab label="{{'CERTIFICAR.ADICIONALES.TABS.QUESTIONS' | translate}}">

        <preguntasAdicionales
        [productoMedir]="productoMedir"
        [idiomas]="idiomas"
        [preguntasAdicionales]="preguntasAdicionales"
        [cargando]="cargando"
        [pasoCompleto]="pasoCompleto"
        (actualizarAdicionales)="actualizarAdicionales($event)"
        (statusSinAdicionales)="actualizaStatusSinAdicionales($event)"
        ></preguntasAdicionales>

        <!--------------------------->
      </mat-tab>

      <mat-tab label="{{'CERTIFICAR.ADICIONALES.TABS.TRANSLATE' | translate}}">

        <traducciones
        [productoMedir]="productoMedir"
        [idiomas]="idiomas"
        [preguntasAdicionales]="preguntasAdicionales"

        [actualizaAdicionales] = "eventsSubject.asObservable()"
        (actualizarAdicionales)="actualizarAdicionales($event)"
        ></traducciones>

      </mat-tab>

      <!-- <mat-tab label="{{'CERTIFICAR.ADICIONALES.TABS.PREVIEW' | translate}}">

        <previsualizacion
        [idiomas]="idiomas"
        [preguntasAdicionales]="preguntasAdicionales"
        [actualizaAdicionales] = "eventsSubject.asObservable()"
        ></previsualizacion>

      </mat-tab> -->

    </mat-tab-group>
  </ng-container>


  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
      (click)="completarPaso()"
    >
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
  </div>

</div>
